var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7751_35499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 0H0V96H96V0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64 94.26C73.64 82.26 65.86 77.39 55.21 76.03V70.6C57.6591 69.2556 59.7906 67.4004 61.46 65.16C63.2023 62.5462 64.4497 59.6345 65.14 56.57L65.38 56.65C67.85 57.08 68.65 54.73 69.38 51.85C70.11 48.97 69.47 47.11 67.85 46.29C68.4421 44.559 68.733 42.7393 68.71 40.91C68.71 26.1 60.54 17.15 48.01 17.15C35.48 17.15 27.31 26.15 27.31 40.91C27.287 42.7393 27.5778 44.559 28.17 46.29C26.55 47.11 25.92 48.97 26.64 51.85C27.36 54.73 28.16 57.08 30.64 56.65H30.71C31.4204 59.7597 32.8179 62.6709 34.8 65.17C36.4805 67.2629 38.5104 69.0492 40.8 70.45V76C30.14 77.39 22.36 82.3 22.36 94.26",
    stroke: "#6F6E6F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.79 76.0699C40.79 80.0699 44.58 81.91 48 81.91C51.42 81.91 55.21 80.1099 55.21 76.0699",
    stroke: "#6F6E6F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.79 70.4399C42.9371 71.8759 45.423 72.724 48 72.8999C50.4962 72.7381 52.9171 71.9802 55.06 70.6899",
    stroke: "#6F6E6F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.33 61.1C50.1755 61.5971 49.866 62.0318 49.4468 62.3404C49.0276 62.6491 48.5206 62.8156 48 62.8156C47.4795 62.8156 46.9725 62.6491 46.5533 62.3404C46.1341 62.0318 45.8246 61.5971 45.67 61.1",
    stroke: "#6F6E6F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.07 32C56.2975 31.174 55.3232 30.5635 54.2431 30.2286C53.1629 29.8936 52.0142 29.8459 50.91 30.09C49.7746 30.3744 48.757 31.0074 48 31.9C47.2401 31.0148 46.2227 30.389 45.09 30.11C43.9874 29.8634 42.8398 29.908 41.7597 30.2394C40.6797 30.5708 39.7045 31.1775 38.93 32C37.7058 33.4477 37.1022 35.3199 37.25 37.21C37.4243 39.0337 38.1184 40.7691 39.25 42.21C40.9211 44.3849 42.9259 46.2817 45.1899 47.83C45.91 48.36 48.02 49.73 48.02 49.73C48.02 49.73 50.1299 48.36 50.8499 47.83C53.114 46.2817 55.1188 44.3849 56.79 42.21C57.9215 40.7691 58.6156 39.0337 58.79 37.21C58.9267 35.3144 58.3084 33.4416 57.07 32Z",
    stroke: "#6F6E6F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.15 38.94H17.15M21.28 12.17L26.2 17.09M85.9 38.94H78.9M74.77 12.17L69.85 17.09M48 1.07996V7.99996",
    stroke: "#6F6E6F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7751_35499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96008);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_008.6d00febe2f979387d1172740da9c8aaf.svg";
export { ForwardRef as ReactComponent };